import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { ContractStanding } from '../services/contractsService';
import { colors } from '../theme/designSystem';

/**
 * Indicativo de contrato nas listas de pacientes e de usuários (RN-558e): "Contrato vigente" ou
 * "Contrato pendente", com o motivo no tooltip (vencido em, aguardando assinatura, sem contrato...).
 * No celular o tooltip abre no toque, sem espera: a informação não pode ficar só no hover.
 */
interface Props {
  standing: ContractStanding | null | undefined;
  onClick?: () => void;
}

const ContractStandingChip: React.FC<Props> = ({ standing, onClick }) => {
  if (!standing) return null;
  const current = standing.status === 'vigente';
  return (
    <Tooltip title={standing.detail} arrow enterTouchDelay={0} leaveTouchDelay={3000}>
      <Chip
        label={current ? 'Contrato vigente' : 'Contrato pendente'}
        size="small"
        onClick={onClick ? (e) => { e.stopPropagation(); onClick(); } : undefined}
        sx={{
          ml: 1,
          height: 20,
          fontSize: '0.7rem',
          fontWeight: 700,
          backgroundColor: current ? colors.successSoft : colors.warningSoft,
          color: current ? colors.successHover : colors.warningSoftText,
          border: `1px solid ${current ? '#b7dfbf' : '#ffe08a'}`,
          '&:hover': { backgroundColor: current ? colors.successSoft : colors.warningSoft },
        }}
      />
    </Tooltip>
  );
};

export default ContractStandingChip;
